import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    active: Boolean
  }

  connect() {
    this.applyState()
  }

  activeValueChanged() {
    this.applyState()
  }

  applyState() {
    const card = this.element.closest(".canvas-card")
    if (!card) return

    const selfEditing = card.dataset.selfEditing === "true"
    const showIndicator = this.activeValue && !selfEditing
    const lockClasses = ["ring-2", "ring-amber-300", "border-amber-300"]

    if (showIndicator) {
      card.classList.add(...lockClasses)
      this.setEditLocked(card, true)
    } else {
      card.classList.remove(...lockClasses)
      this.setEditLocked(card, false)
    }

    // Hide the indicator text for the editing user
    const indicatorContent = this.element.querySelector("div")
    if (indicatorContent) {
      indicatorContent.classList.toggle("hidden", !showIndicator)
    }
  }

  setEditLocked(card, locked) {
    const editActions = card.querySelectorAll('[data-action*="canvas-card#edit"]')
    editActions.forEach(el => {
      el.dataset.editLocked = locked ? "true" : "false"
    })

    const lockableButtons = card.querySelectorAll('[data-card-lockable]')
    lockableButtons.forEach(el => {
      el.disabled = locked
      el.classList.toggle("opacity-30", locked)
      el.classList.toggle("pointer-events-none", locked)
    })
  }
}
